import Vue from 'vue';

var authPlugin = {
    setToken: function(token, expiretion){
        localStorage.setItem('authToken', token);
        localStorage.setItem('authTokenExpiretion', expiretion);

    },
    destroyToken: function(){
        localStorage.removeItem('authToken');
        localStorage.removeItem('authTokenExpiretion');

    },

    getToken: function(){
        var token = localStorage.getItem('authToken');
        var expiretion = localStorage.getItem('authTokenExpiretion');
        if(!token || !expiretion) {
            return null;
        }

        if(Date.now() > parseInt(expiretion)) {
            this.destroyToken();
            return null;
        } else {
            return token;
        }
    },

    loggedIn: function(){
        if(this.getToken()) {
            return true;
        }
        return false;
    }
};


export default function(Vue) {
    Vue.auth = authPlugin;

    Object.defineProperties(Vue.prototype, {
        $auth: {
            get: () => Vue.auth
        }
    });
}


// WEBPACK FOOTER //
// ./vue/plugins/auth.js